module.exports = __webpack_public_path__ + "static/58b23aca3ca65fc0d3fdc40479ff5e2f95afcb4138a66d53944333f045f756ea-5bec1937edab2e74778e93b7b2feac93.jpeg";